import webhookApi from '@/api/webhook'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totals: [],
  sources: [],
  totalCount: 0,

  receiverAvailable: false,
  loading: false,
  loaded: false,
  error: null,

  details: null,
  detailsLoading: false,
  detailsError: null,
}

const errorText = (error, fallback) => error.response?.data?.message || fallback

let lastListRequest = 0

const getters = {}

const actions = {
  async fetchList({ commit }, filters) {
    lastListRequest += 1

    const request = lastListRequest

    commit('SET_LOADING')
    try {
      const { data } = await webhookApi.getAll({
        pageNumber: filters.pageNumber,
        pageSize: filters.pageSize,

        status: filters.status || undefined,
        source: filters.source || undefined,
        search: (filters.search || '').trim() || undefined,
        dateFrom: filters.dateFrom || undefined,
        dateTo: filters.dateTo || undefined,
      })

      if (request === lastListRequest) commit('SET_LIST', data)
    } catch (error) {
      if (request === lastListRequest) {
        commit('SET_LIST_ERROR', errorText(error, 'Не удалось прочитать журнал вебхуков'))
      }
    }
  },

  async openDetails({ commit }, row) {
    commit('DETAILS_LOADING', row)
    try {
      const { data } = await webhookApi.getById(row.id)
      commit('SET_DETAILS', data)
    } catch (error) {
      commit('SET_DETAILS_ERROR', {
        id: row.id,
        text: errorText(error, 'Не удалось прочитать тело вебхука'),
      })
    }
  },

  closeDetails({ commit }) {
    commit('CLOSE_DETAILS')
  },
}

const mutations = {
  SET_LOADING(state) {
    state.loading = true
  },
  SET_LIST(state, data) {
    state.list = data.items || []
    state.totals = data.totals || []
    state.totalCount = data.metadata ? data.metadata.totalItemCount : 0
    state.receiverAvailable = data.receiverAvailable === true

    if (state.receiverAvailable) state.sources = data.sources || []

    state.error = null
    state.loading = false
    state.loaded = true
  },
  SET_LIST_ERROR(state, text) {
    state.list = []
    state.totals = []
    state.totalCount = 0
    state.error = text
    state.loading = false
    state.loaded = true
  },
  DETAILS_LOADING(state, row) {
    state.details = row
    state.detailsLoading = true
    state.detailsError = null
  },

  SET_DETAILS(state, data) {
    if (!state.details || state.details.id !== data.id) return

    state.details = data
    state.detailsLoading = false
  },
  SET_DETAILS_ERROR(state, { id, text }) {
    if (!state.details || state.details.id !== id) return

    state.detailsError = text
    state.detailsLoading = false
  },
  CLOSE_DETAILS(state) {
    state.details = null
    state.detailsLoading = false
    state.detailsError = null
  },
  ...generateFormHandlerMutations(state),
}

const modules = {}

const watchers = []

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
